import { StoryType } from '../models/story-type.enum';

export function storyType(storyId: string): StoryType {
  return (storyId.split('/').length > 1) ? StoryType.Module : StoryType.Bookmark;
}
